<template>
    <div name="kakao-button" class="button-box">
        <div @click="btnClick" class="button">
            <img class="image" src="../../assets/kakao.png" />
            <span class="text">카카오 채팅상담</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kakaoButton',
    methods: {
        btnClick: function()
        {
            this.$emit('onClick')
        }
    }
}
</script>

<style scoped>
    .button-box{
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        padding: 0px 16px;
        padding-top: -10px;
        padding-bottom: 30px;
    }
    .button {   
        width: calc(100% - 32px);
        height: 117px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFE601;
        border-radius: 6px;
        border: 1px solid var(--Gray-50, #A3AAB6);
        cursor: pointer;
    }
    .image{
        width: 24px;
    }
    .text {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -0.72px;
        margin-left: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/KakaoButton.vue